import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import Select from '../../ui/Select';
import { formatLangCode } from '../../helpers';
import { APP_LANGUAGES } from '../../app.config.vars/languages';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
const LangSelector = ({}) => {
    const { i18n } = useTranslation();
    const handleChange = async (selectedOptionValue) => {
        await i18n.changeLanguage(selectedOptionValue);
    };
    const currentLang = APP_LANGUAGES.find((lang) => lang.code === formatLangCode(i18n.language));
    return (_jsx("div", { className: 'lang-selector on-print-hidden', children: _jsx(Select, { defaultSelectedOptionValue: currentLang.code, options: APP_LANGUAGES.map((lang) => {
                return { ...lang, value: lang.code };
            }), onChange: handleChange, background: 'gray', fontSize: 'small', zIndex: 10, manageIsSelected: false, highlightSelected: false, offlineChangeDisable: true, offlineChangeModalContent: MODAL_CONTENT.noInternetToChangeLanguage.key }) }));
};
export default LangSelector;
